import React from "react";

import useCheckDevice from "@repo/shopifyV2/hooks/useCheckDevice";

import Button from "@atoms/Button";
import Dim from "@atoms/Dim";
import Icon from "@atoms/Icon";

import { useLayoutStore } from "@store/layout";

interface IProps {
  handleCancel: () => void;
  children: React.ReactNode;
  isEdit?: boolean;
}

export default function AddressLayout({ handleCancel, children, isEdit }: IProps) {
  const { isPC } = useCheckDevice();
  const { modal } = useLayoutStore();

  return (
    <>
      {/* 우편번호 찾기 등 모달이 열리면 Dim이 겹치므로, 모달 Dim 하나만 남기고 주소 폼은 그 아래로 내린다 */}
      {modal ? null : <Dim onClick={handleCancel} />}
      <section className="pc:h-dvh pc:max-h-dvh pc:w-1/3 pc:pt-4 pc:p-5 pc:z-50 pc:gap-5 fixed top-0 right-0 z-40 flex h-dvh w-full flex-col bg-white p-4 pt-0 lg:w-1/4 dark:text-white">
        {isPC ? (
          <div className="flex w-full justify-between">
            {isEdit ? (
              <Button as="wrapper" className="items-center gap-2" onClick={handleCancel}>
                <Icon className="h-3 dark:text-white" name="LeftArrow" />
                <span> {isEdit ? "Back to Address Book" : "Back"}</span>
              </Button>
            ) : (
              <span>Address Book</span>
            )}

            <Button as="text" onClick={handleCancel}>
              Close
            </Button>
          </div>
        ) : (
          <div className="tnt-gap-x grid h-13.5 min-h-13.5 grid-cols-8 items-center py-4">
            <Button as="wrapper" className="col-span-1" onClick={handleCancel}>
              <Icon className="h-3.5 dark:text-white" name="LeftArrow" />
            </Button>
            <Button as="text" className="col-span-7 text-base!" onClick={handleCancel}>
              {isEdit ? "Back to Address Book" : "Back"}
            </Button>
          </div>
        )}

        {children}
      </section>
    </>
  );
}
